import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import collaborationActions from '../actions/collaboration'

export const useCollaboration = () => {
  const data = useSelector((state) => {
    return get(state, 'app.collaborationManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(collaborationActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
